import functions from "./functions.js";
import lozad from 'lozad';
import pagination from "./pagination.js";

const list = {
    showExtra: 0,
    // references
    $form: null,
    form: null,
    $list: null,
    list: null,
    $listItems: null,
    $listNoResults: null,
    $loader: null,
    $pagination: null,
    productCategory: null,
    productCategories: {
        1: 'Accommodation',
        3: 'Charter',
        6: 'Cruise'
    },
    // form params
    params: {},
    // params from shortcode and starting ones
    defaults: {
        dateFrom: '',
        dateTo: '',
        destination: '',
        sortBy: 0,
        _page: 1,
        perPage: 12,
        persons: '',
        language: '',
        tagCategoryId: '',
    },
    defaultsCharter: {
        objectTypeId: '',
        cabinsFrom: '',
        lengthFrom: '',
        yearFrom: '',
        berths: ''
    },
    defaultsAccommodation: {
        bedrooms: '',
        parking: '',
        pets: '',
        pool: '',
        rivieraId: '',
        placeId: '',
    },
    defaultsCruise: {
        duration: '',
        sortBy: '6:ASC'
    },
    hiddenParams: ['language', 'perPage', 'rivieraId', 'placeId', 'tagCategoryId'],
    // set by hash change to prevent change event on form fields
    pauseChange: false,
    // hashchange and form fields change are delayed
    changeTimeout: null,
    loading: false,
    // ajax load id
    loadId: 0,
    total: null,
    // for non ajax form to reset page on normal submit
    paginated: true,
    disabledFields: {},
    $showingTotal: null,
    $showingFrom: null,
    $showingTo: null,
    isHome: null,
    // methods
    getDefaults() {
        let defaults = $('.form-search').attr('data-params');
        defaults = defaults ? JSON.parse(defaults) : {};
        // merge global defaults with defaults special for current category
        list.defaults = $.extend({}, list.defaults, list[list.productCategory], defaults);

    },

    // get URL params and merge with defaults - (ex. things changed after init search)
    getParams() {
        list.params = $.extend({}, list.defaults, functions.getUrlData(true));
        
    },
    getFormData($form) {
        let formData = $.extend(functions.getFormData($form || list.$form), {
            _page: list.paginated ? list.params._page : 1
        });
        list.paginated = true;
        // do not send same values as defaults
        $.map(formData, (val, key) => {
            if (list.defaults[key] == val) {
                delete formData[key];
            }
        });
        return formData;
    },
    init() {
        list.$form = $('.form-search');
        list.form = list.$form[0];

        // list.advanced = list.$form.hasClass('form-advanced');
        // list.isHome = $('body.home')[0];
        if (!list.form) {
            return;
        }

        list.productCategory = list.productCategories[list.$form.attr('data-objectGroupId')];
        
        if (list.productCategory) {
            list.productCategory = 'defaults' + list.productCategory;
        }

        list.getDefaults();
        list.setDisabledFields();
        list.getParams();
        
        functions.setFormData(list.form, list.params);

        if (!list.isHome) {
            list.find();
        }


        // register form submit
        list.$form.on('click', '.submit-form', e => {
            e.preventDefault();
            list.params._page = 1;
            functions.setUrlData(list.prepareUrlData(), true);
        });

        list.$form.find('.reset-form').on('click', e => {
            functions.setFormData(list.form, list.defaults);
            $('.choose-date').removeClass('d-none');
            $('.form-dates-left, .form-dates-right').addClass('d-none');
        });

        // register hashchange which trigger find
        $(window).on('hashchange', () => {
            list.pauseChange = true;
            clearTimeout(list.changeTimeout);
            list.changeTimeout = setTimeout(() => {
                list.getParams();
                functions.setFormData(list.form, list.params);
                list.find();
                list.pauseChange = false;
            }, 100);
        });

        // register paginate        
        $(document).on('click', '.pagination [data-page]', e => {
            e.preventDefault();
            list.paginate(+$(e.currentTarget).attr('data-page'));
        });

        $('.sort-by').on('select2:select', () => {
            functions.setUrlData(list.prepareUrlData(), true);
        });



        // $(document).on('click', '.reset-form', () => {
        //     functions.resetFormData($('.search-form')[0]);
        //     $('.choose-date').removeClass('d-none');
        //     $('.form-dates-left, .form-dates-right').addClass('d-none');
        // });
    },
    prepareUrlData() {
        let o = {};
        $.map(list.getFormData(), (val, key) => {
            if (list.hiddenParams.indexOf(key) == -1) {
                o[key] = val;
            }
        });
        return o;
    },
    setDisabledFields() {
        $.map((list.defaults.disabledfields || '').split(','), (name) => {
            if (list.form[name]) {
                list.disabledFields[name] = true;
                list.form[name].disabled = true;
            }
        });
    },
    setLoadingMode($form) {
        if (!list.loading) {
            list.loading = true;
            // form submit btn
            ($form || list.$form)
                .find('.form-submit').prop('disabled', true);

            $('.spinner').removeClass('d-none');
            $('.spinner').addClass('d-flex justify-content-center');
            $('.list').addClass('d-none');
            
            list.$list.addClass('loading');
            list.loadId && functions.scrollToElement(list.$list, 100);
        }
    },
    unsetLoadingMode() {
        if (list.loading) {
            list.loading = false;
            list.$form
                .find('.form-submit').prop('disabled', false);

            $('.spinner').removeClass('d-flex justify-content-center');
            $('.spinner').addClass('d-none');
            $('.list').removeClass('d-none');
            
            list.$list.removeClass('loading');
            list.loadId > 1 && functions.scrollToElement(list.$list, 100);
        }
    },
    find() {
        // init list
        if (!list.$list) {
            list.$list = $('.list');
            list.list = list.$list[0];

            list.$listItems = list.$list.find('.list-items');
            list.$listNoResults = list.$list.find('.list-no-results').removeClass('d-none').remove();
            list.$loader = list.$list.find('.list-loader');
            list.$pagination = $('<nav class="d-flex justify-content-center" aria-label="Page navigation example">').appendTo(list.list);
            // list.$showingFrom = $('.showingFrom');
            // list.$showingTo = $('.showingTo');
            // list.$showingTotal = $('.showingTotal');
        }


        list.setLoadingMode();
        let ajaxId = ++list.loadId;

        $.get('/services/list.php', list.params).then(response => {
            if (ajaxId !== list.loadId) {
                return;
            }
            response = JSON.parse(response);
            list.total = response.total;

            if (list.total != 0) {
                // list slider init

                list.$listItems.html(response.html);
                list.$pagination.html(pagination({
                    currentPage: list.params._page,
                    total: list.total,
                    perPage: list.defaults.perPage,
                }));
                window.observer.observe();

                const cardImageSlider = () => {
                    $(".card-img-slider").lightSlider({
                        item: 1,
                        slideMargin: 0,
                        pauseOnHover: true,
                        loop: true,
                        mode: 'fade',
                        //auto: true,
                        pager: false,
                        pause: 5000,
                        speed: 500,
                        enableDrag: false,
                        controls: true,
                        prevHtml: '<i class="las la-angle-left text-white p-1 rounded" style="font-size: 1.1rem; background-color: #393844cc;"></i>',
                        nextHtml: '<i class="las la-angle-right text-white p-1 rounded" style="font-size: 1.1rem; background-color: #393844cc;"></i>'
                    });
                };

                cardImageSlider();

                // $('.list-information').removeClass('d-none');
                // if (list.total <= list.params._page * list.defaults.perPage && list.total >= (list.params._page - 1) * list.defaults.perPage) {
                //     list.$showingTo.text(list.total);
                // } else {
                //     list.$showingTo.text(list.params._page * list.defaults.perPage);
                // }
                // list.$showingTotal.text(list.total);
                // list.$showingFrom.text(list.params._page * list.defaults.perPage - (list.defaults.perPage - 1));
            } else {
                // $('.list .form-row, .list .list-pagination').addClass('d-none');
                // $('.list-information').addClass('d-none');

                const lang = functions.getLang();

                let output = lang == 'hr' ? 
                    'Nažalost nema objekta koja odgovaraju zadanim kriterijima. Molimo pokušajte s drugim kriterijima.' 
                    : (lang == 'de' 
                        ? 'Leider gibt es keine Objekte, die den angegebenen Kriterien entsprechen. Bitte versuchen Sie eine andere Suche mit anderen Kriterien.' 
                        : 'Unfortunately there are no objects matching the given criteria. Please try another search with different criteria.'
                    );

                list.$listItems.html('<div class="m-5 p-5"><p>' + output + '</p></div>');
            }

            list.unsetLoadingMode();

        });
    },
    paginate(page) {
        if (page != list.params._page) {
            list.params._page = page;
        }

        functions.setUrlData(list.prepareUrlData(), true);
    }
}


$(() => {
    list.init();
});